import { ChevronDown, ChevronRight } from 'lucide-react';
import type { AdresseInput } from '@/types/bestellung';
import { FELD_KLASSE } from '@/lib/feldKlassen';

type Props = {
  abweichend: boolean;
  adresse: AdresseInput;
  onToggle: () => void;
  onChange: (patch: Partial<AdresseInput>) => void;
};

const inputClass = FELD_KLASSE;

export function RechnungsadresseSection({ abweichend, adresse, onToggle, onChange }: Props) {
  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        className="inline-flex min-h-[44px] items-center gap-2 text-sm text-ink-soft hover:text-akzent"
      >
        {abweichend ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        Abweichende Rechnungsadresse
      </button>
      {abweichend && (
        <div className="mt-2 grid grid-cols-2 gap-2 rounded-md border border-line bg-cream-warm p-3">
          <input
            className={inputClass + ' col-span-2'}
            placeholder="Anrede / Firma z.Hd."
            value={adresse.anrede}
            onChange={(e) => onChange({ anrede: e.target.value })}
          />
          <input
            className={inputClass + ' col-span-2'}
            placeholder="Straße"
            value={adresse.strasse}
            onChange={(e) => onChange({ strasse: e.target.value })}
          />
          <input
            className={inputClass}
            placeholder="PLZ"
            value={adresse.plz}
            onChange={(e) => onChange({ plz: e.target.value })}
          />
          <input
            className={inputClass}
            placeholder="Ort"
            value={adresse.ort}
            onChange={(e) => onChange({ ort: e.target.value })}
          />
          <input
            className={inputClass + ' col-span-2'}
            placeholder="Land"
            value={adresse.land}
            onChange={(e) => onChange({ land: e.target.value })}
          />
        </div>
      )}
    </div>
  );
}
